/**
 * Maps ACL module codes to application route paths.
 * Update this map when new modules or routes are added.
 */
export const MODULE_ROUTES: Record<string, string> = {
  HOME: '/',
  PROFILE: '/profiles',
  REQUISITION: '/requisitions',
  COUNTRIES: '/countries',
  USERS: '/users',
  STATUS_CODES: '/status-codes',
  SOURCES: '/sources',
  SKILLS: '/skills',
  COMMS: '/communications',
  INTERVIEW_QUESTIONS: '/interview-questions',
  MAINTENANCE: '/maintenance',
  VIDEOS: '/videos',
  REPORTS: '/reports',
  MED_EXAMS: '/medical-exams',
};

export const SUBMODULE_ROUTES: Record<string, Record<string, string>> = {
  HOME: {
    DASHBOARD: '/',
  },
  PROFILE: { 
    LIST_SEARCH: '/profiles/list',
    DOCUMENT_SEARCH: '/profiles/applicant-documents',
    BENEFIT_SEARCH: '/profiles/benefits/search',
  },
  REQUISITION: {
    ALL_REQUISITIONS: '/requisitions',
    MY_REQUISITIONS: '/requisitions/my',
    CREATE_REQUISITION: '/requisitions/create',
  },
  SOURCES: {
    SOURCE_LIST: '/sources',
    ADD_SOURCE: '/sources/create', 
    GET_LINK: '/sources/link',
  },
  USERS: {
    USERS_LIST: '/users',
    ADD_USER: '/users/add',
    EDIT_USER: '/users/edit/:userId',
  },
};